import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguagePopover } from 'src/components/molecules/language-popover';
import { useSettingsStore } from 'src/store/settings-store';

interface Props {
  hideLogo?: boolean;
  title: string;
  description: string;
  icon: ReactNode;
}

const AuthFormHeader = ({ title, description, icon }: Props) => {
  const { i18n } = useTranslation();

  const saveSettings = useSettingsStore(state => state.saveSettings);

  const handleLanguageChange = (language: 'en' | 'pl'): void => {
    i18n.changeLanguage(language);
    saveSettings({
      language,
    });
  };

  return (
    <>
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
        <LanguagePopover
          language={i18n.language}
          onLanguageChange={handleLanguageChange}
          textMode
        />
      </Box>
      {icon ? <Box sx={{ textAlign: 'center', mb: 1 }}>{icon}</Box> : null}
      <Typography
        align="center"
        variant="h6"
        color="black"
        sx={{ fontSize: '22px', fontWeight: 500 }}>
        {title}
      </Typography>
      <Typography variant="body2" align="center" color="black">
        {description}
      </Typography>
    </>
  );
};

export default AuthFormHeader;
